import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiService } from './../../../../../Services/api.service';
import { LoaderService } from './../../../../../Services/loader.service';
import { StorageService } from "./../../../../../Services/storage.service"
import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from './../../../../../Services/excel.service';
import { S3BudgetService } from "./../../../../../Services/s3Budget.service";
import { Observable } from 'rxjs';
import { SubjectService } from 'src/app/Services/subject-services';
import { map, startWith } from 'rxjs/operators';
import { resolve } from 'dns';
import { rejects } from 'assert';
// const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'DD-MM-YYYY',
//   },
//   display: {
//     dateInput: 'YYYY-MM-DD',
//     monthYearLabel: 'MMMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY'
//   },
// };



@Component({
  selector: 'app-movement-reports',
  templateUrl: './moment-reports.component.html',
  styleUrls: ['./moment-reports.component.css'],
  // providers: [
  //   { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  // ]
})
export class MomentReportsComponent implements OnInit {

  public formFilters: any = FormGroup;
  @ViewChild('search') searchTextBox: ElementRef;

  selectFormControl = new FormControl();
  public timeIntravel: any = {
    1: 10,
    2: 60,
    3: 300,
    4: 600
  };
  public timeIntervalSec: any = {
    10: '10 Seconds',
    60: '1 Minute',
    300: '5 Minutes',
    600: '10 Minutes',
  }
  public excelData = {};
  public allVehDownload: boolean;
  public tableData = [];
  public cols = [
    { key: '#', display: '#' },
    { key: 'Date', display: 'Date', headerConfig: { isDefault: true } },
    { key: 'Time', display: 'Time', headerConfig: { isDefault: true } },
    { key: 'Location', display: 'Location' },
    { key: 'Status', display: 'Status' },
    { key: 'Speed', display: 'Speed (km/h)', style: 'align:center', headerConfig: { isDefault: true } },
    { key: 'Distance', display: 'Total distance (km)', headerConfig: { isDefault: true } },

  ];

  public enableAllOption: boolean = true;
  public multiSelectVehicle: boolean = false;
  public noDataFoundEnable: boolean = false;
  public localStorage;
  public processedData: any = {};
  public objectKeys = Object.keys;
  public totalDistance: any = 0;
  public myDate = new Date();
  public maxDate: any;
  searchTextboxControl: any;
  // selectFormControl: any;
  data: any;
  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public storage: StorageService,
    public s2Service: S3BudgetService,
    private subject: SubjectService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    // this.localStorage;
    this.localStorage = this.storage.get('vendorID_orgID');

    this.getRegNos();
    this.getVehicleDetails();
  }

  public vehicleRegNos: any
  public showTable: boolean;
  public vehicles = [];
    filteredOptions: Observable<any[]>;
  selectedValues = [];

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
        console.log('vehicle ',this.vehicles);
      }
    }).catch((err) => {
      console.log(err);
    });

  }



  ngOnInit(): void {
    this.reactiveForm();
    // ensure report_submit is reset so LoaderService behaves correctly
    this.storage.setData({ report_submit: false });
  }

   reactiveForm() {
    this.formFilters = this.fb.group({
      selectedVehicle: ['', Validators.required],
      // singleDay : ['', Validators.required],
      sDate: ['', Validators.required],
      eDate: ['', Validators.required],
      speedLimit: ['', Validators.required],
    }, {
      validator: [this.comService.formToDateValidation('sDate', 'eDate', 'selectedVehicle')]
    });
  }

  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  async getVehicleEncryptRegNo(regNo) {
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }
  writeExcelData(startDate, endDate, veh, data) {

  }
  async submitForm(obj: any) {
    try {
      if (obj) {
        // mark this as a long-running report so LoaderService does not hide on each HTTP call
        this.storage.setData({ report_submit: true });
        let process_count=0;
        let processdata=0;
        let getdata_count=0;
        let filterValues = obj.formFilds;
        // this.vehicles = obj.vehicles;
        this.allVehDownload = false;
        this.showTable = true;
        this.tableData = [];
        this.totalDistance = 0;
        this.showTable = false;
        this.noDataFoundEnable = false;
        this.loader.show();
        const vehicle = filterValues.selectedVehicle;
        const startDate = new Date(filterValues.sDate + '');
        const endDate = new Date(new Date(new Date(filterValues.eDate).setHours(23, 59, 59)) + '');
        // let endDate:any;
        // endDate = new Date(new Date(filterValues.eDate + '').setHours(23, 59, 59));
        // if (!endDate || isNaN(new Date(endDate).getTime())) {
        //   endDate=startDate
        // } 


        const arr: any = []
        let getDaysArray: any = function (start, end) {
          for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            const date = new Date(dt);
            arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
          }
          return arr;
        };
        const pad = (num) => {
          return num > 9 ? num : '0' + num;
        };

        const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
        const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate()); //by rao
        let daylist: any = getDaysArray(new Date(start), new Date(end));//byrao
        //let daylist: any = getDaysArray(new Date(start), new Date(start));
        const timeIntravel = filterValues.timeInteravel ? this.timeIntravel[filterValues.timeInteravel] : 10;
        // const vehicleList = await this.comService.vehicleToObject(this.vehicles, vehicle);
        // const vehLen = this.objectKeys(vehicleList);   console.log('vehicleList ', vehLen)
        // let vehLen = [];
        // if (!Array.isArray(filterValues.selectedVehicle)) vehLen = [filterValues.selectedVehicle];
        // else vehLen = filterValues.selectedVehicle;
        // daylist = [...new Set(daylist)];

         const vehLen = obj.formFilds.selectedVehicle === 'ALL'
          ? this.vehicles.filter((veh:any) => veh.vehRegNo).map((veh:any) => veh.vehRegNo).sort()
          : [obj.formFilds.selectedVehicle];

        const checkCurrentDay = (date) => {
          var inputDate = new Date(date);
          // Get today's date
          var todaysDate = new Date();
          // call setHours to take the time out of the comparison
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
          else return false;
        };

        // let vehRegString = '';
        // for (let veh = 0; veh < vehLen.length; veh++) {
        //   vehRegString = vehRegString + ',' + vehLen[veh];   
        // }
        let vehRegString = '';
      for (let veh = 0; veh < vehLen.length; veh++) {
        if (vehLen[veh]) {
          if (vehRegString == '') vehRegString = vehLen[veh];
          else vehRegString = vehRegString + ',' + vehLen[veh];
        }
      }

        let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehLen).catch((e) => { console.log('unable to veh reg no'); })
        let keys=Object.keys(vehRegEncryKey);
        // this.loader.show();
        for (let veh = 0; veh < vehLen.length; veh++) {
          // Running total distance per vehicle (resets for each vehicle, including ALL selection)
          let vehicleTotalDistance: number = 0;
          let pdata: any = [], excel = [];
          if (this.processedData[vehLen[veh]] == undefined)  this.processedData[vehLen[veh]] = {}; 
          
          // for (let day = 0; day < daylist.length; day++) {
          //   let checkDay = checkCurrentDay(daylist[day]);
          //   if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
          //   if (!checkDay) {
          //     this.loader.show();
          //     const splitDate = daylist[day].split('/');
          //     const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
          //     if (vehRegEncryKey[vehLen[veh]] != null) {
          //       const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
          //       const res = await this.api.readS3Data(url).catch((e) => { });
          //       if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {

          //         let tempData: any = await this.processData(res, timeIntravel);
          //         excel = [...excel, ...tempData['xldata']];
          //         pdata = [...pdata, ...tempData['data']];
          //         this.loader.hide();
          //       } else {
          //         let tempData: any = {
          //           "data": [
          //             {
          //               DateTime: this.comService.convertDateString(daylist[day]),
          //               Location: '---',
          //               Status: '---',
          //               Distance: '---',
          //               Speed: "---",
          //               ts: '---',
          //               gpsts: '----'
          //             }
          //           ],
          //           "xldata": [
          //             {
          //               "value": [
          //                 this.comService.convertDateString(daylist[day]),
          //                 '---',
          //                 '---',
          //                 '---',
          //                 '---',
          //               ]
          //             }
          //           ]
          //         }

          //         excel = [...excel, ...tempData['xldata']];

          //         let resValue = {
          //           DateTime: this.comService.convertDateString(daylist[day]),
          //           Location: '---',
          //           Status: '---',
          //           Distance: '---',
          //           Speed: "0",
          //           ts: '---',
          //           gpsts: '----'
          //         }
          //         this.tableData.push(resValue)
          //       }

          //     }
          //   } else {
          //     this.loader.show();
          //     let obj = {
          //       vehRegNo: vehLen[veh],
          //       date: new Date().setHours(0, 0, 0)
          //     };
          //     if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
          //     let getData = await this.comService.currentDayTrackingData(obj).catch((e) => { console.log('Unable to get current day data.'); });
          //     let tmpData: any = await this.processData(getData, timeIntravel);
          //     excel = [...excel, ...tmpData['xldata']];
          //     pdata = [...pdata, ...tmpData['data']];
          //     this.loader.hide();
          //   }
          //   this.processedData[vehLen[veh]][daylist[day]] = pdata;
          // }

          for (let day = 0; day < daylist.length; day++) {
            let checkDay = checkCurrentDay(daylist[day]);
            if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
            if (!checkDay) {
              this.loader.show(); //yy
              if (vehRegEncryKey[vehLen[veh]] != null) {
               
                const splitDate = daylist[day].split('/');
                const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                const res = await this.api.readS3Data(url).catch((e) => { });
                if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {

                  if (this.processedData[vehLen[veh]][daylist[day]] == undefined){ 
                    this.processedData[vehLen[veh]][daylist[day]] = {}; 
                }else{
                  console.log("4444444444");
                  process_count++;
                 processdata++;
                }
                  let tempData: any = await this.processData(res, timeIntravel, 0);
                  const dayTotal = tempData.totalDistance || 0;
                  this.totalDistance = (this.totalDistance || 0) + dayTotal;
                 
                  excel = [...excel, ...tempData['xldata']];
                  pdata = [...pdata, ...tempData['data']];
                  // console.log('P data ', pdata.data.length, pdata);
                    //this.loader.hide();//yy
                }
              }
            }
            else {
              //this.allVehDownload = false;
                this.loader.show(); //yy
              let obj = {
                vehRegNo: vehLen[veh],
                date: new Date().setHours(0, 0, 0)
              };
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
              let getData = await this.comService.currentDayTrackingData(obj).catch((e) => { console.log('Unable to get current day data.'); });
              if(getData!==undefined){
                processdata++;
                getdata_count++;
                let tmpData: any = await this.processData(getData, timeIntravel, 0);
                const dayTotal = tmpData.totalDistance || 0;
                this.totalDistance = (this.totalDistance || 0) + dayTotal;
                excel = [...excel, ...tmpData['xldata']];
                pdata = [...pdata, ...tmpData['data']];
              }
               // this.loader.hide();//yy
            }
            this.processedData[vehLen[veh]][daylist[day]] = pdata;
          }
          if (excel.length > 0) {

            let rowCount = 2;
            let endCell = 'G';
            let customizedData = [];
            let titleRow = {
              value: ['Movement Report'],
              font: {
                name: 'Corbel', family: 4, size: 16, bold: true,
                color: { argb: 'FFFFFFFF' },

              },
              mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
              alignment: {
                cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
              },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '966462AF' },
                bgColor: { argb: '966462AF' }
              },
            }

            customizedData.push(titleRow);

            rowCount = rowCount + 4;

            let subtitleRow = {
              value: [
                "Vehicle            : " + String(vehLen[veh]).toUpperCase() + "\n" +
                "Start Date       : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                "End Date         : " + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY') + "\n" +
                "Time Interval  : " + this.timeIntervalSec[timeIntravel] + "",
              ],
              font: { name: 'Corbel', family: 4, size: 12, },
              mergeCells: `A${(rowCount - 3) + ''}:${endCell + rowCount + ''}`,
            }

            customizedData.push(subtitleRow);
            rowCount = rowCount + 1;
            let headerRow =
            {
              value: ['S No', 'Date', 'Time', 'Location', 'Status', 'Speed', 'Total distance'],
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
              },
              font: { bold: true },
              border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);
            let sNo = 1;
            excel = excel.map((item) => {
              rowCount++;
              item['value'] = [sNo, ...item['value']];
              let colorCode = "FF008000"
              if (item['value'][4] == 'Halt') colorCode = "FFFF0000";
              item['cellConfig'] = {
                cells: [{
                  cell: `E${rowCount}`,
                  font: { color: { argb: colorCode } },
                }, {
                  cell: `F${rowCount}`,
                  font: { color: { argb: colorCode } },
                }]
              },
                sNo++;
              return item;
            })
            customizedData.push(...excel);

            // const excelInfo = {
            //   title: {
            //     title: 'Movement Report',
            //     subTitleRow: 'Date : ' + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S') ,
            //     font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
            //     mergeCells: 'A1:F2',
            //   },
            //   header: {
            //     headers: ['S.No','Date Time', 'Location', 'Status', 'Speed', 'Total Distance'],
            //     fill: {
            //       type: 'pattern',
            //       pattern: 'solid',
            //       fgColor: { argb: 'FFFFFF00' },
            //       bgColor: { argb: 'FF0000FF' }
            //     },
            //     border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            //   },
            //   data: {
            //     data: excel,
            //     columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 100 }, { colNo: 4, width: 20 }, { colNo: 5, width: 20 }, { colNo: 6, width: 20}]
            //   }
            // };

            if (this.excelData[vehLen[veh].toUpperCase()] == undefined) { this.excelData[vehLen[veh].toUpperCase()] = {}; }
            this.excelData[vehLen[veh].toUpperCase()] = {
              customizedData: customizedData,
              data: {
                columWith: [
                  { colNo: 1, width: 10 },  // S No
                  { colNo: 2, width: 20 },  // Date
                  { colNo: 3, width: 20 },  // Time
                  { colNo: 4, width: 100 }, // Location
                  { colNo: 5, width: 20 },  // Status
                  { colNo: 6, width: 20 },  // Speed
                  { colNo: 7, width: 20 }   // Total distance
                ]
              }
            };
          }
        }

        if (!vehLen.includes('ALL') && vehLen.length <= 1) {
          this.tableData.sort(function (x, y) {
            return x.gpsts - y.gpsts;
          });
          this.showTable = true;
        } else {
          this.allVehDownload = true;
        }
        this.noDataFoundEnable = true;
        this.loader.hide();
        this.subject.broadcast({
          for: 'progress_handle',
          payload: true
        });
        this.storage.setData({ report_submit: false });

      }
    } catch (error) {
      console.log(error);
      this.loader.hide();
      this.subject.broadcast({
        for: 'progress_handle',
        payload: true
      });
      this.storage.setData({ report_submit: false });
    }
  }

  private formatDistance(value: number | string): string {
    let num = Number(value || 0);
    if (isNaN(num)) {
      num = 0;
    }
    const fixed = num.toFixed(2);
    const parts = fixed.split('.');
    const intPart = parts[0];
    const decPart = parts[1] || '00';
    const intPadded = intPart.length < 2 ? '0' + intPart : intPart;
    return intPadded + '.' + decPart;
  }

  private formatSpeed(value: number | string): string {
    let num = Number(value || 0);
    if (isNaN(num)) {
      num = 0;
    }
    const rounded = Math.round(num);
    const intStr = String(rounded);
    return intStr.length < 2 ? '0' + intStr : intStr;
  }

  processData(data: any, minInterval: any, baseDistance: number = 0) {
    return new Promise((resolve, reject) => {
      // console.log('P1', data)
      try {
        const procesedData: any = [];
        const sortingData = {};
        if (data && data.length > 0) {
          data.map((item) => {
            // item.speed = 44;
            if (item.gpsts !==undefined) {
              item.date = this.comService.timestampToDate(item.gpsts, 'DMY H:M:S');
              sortingData[item.gpsts] = item;
            }
          });
        }
        else {
          this.noDataFoundEnable = true;
        }
        // running total distance for this call, seeded with baseDistance so it can
        // continue across multiple days for the same vehicle
        let totalDis: any = baseDistance;
        const objKeys = this.objectKeys(sortingData);
        if (objKeys && objKeys.length) {
          let ind = 1;
          const temp: any = [];
          const tempEx = [];
          for (let i = 0; i < objKeys.length; i++) {
            let prevKey = null, next = null, currentKey = objKeys[i], pre = null;

            if (i > 0) { prevKey = procesedData[procesedData.length - 1]; }
            if (objKeys[i + 1]) { next = objKeys[i + 1]; }
            let curdis = 0;
            if (i > 0) {
              pre = objKeys[i - 1];
              const lat1 = parseFloat(sortingData[currentKey].lat);
              const lat2 = parseFloat(sortingData[pre].lat);
              const lng1 = parseFloat(sortingData[currentKey].lng);
              const lng2 = parseFloat(sortingData[pre].lng);
              if ((lat1 == lat2) && (lng1 == lng2)) { curdis = 0; } else {
                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                  dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = (dist * 1.609344);
                curdis = parseFloat(dist);
              }
            }
            totalDis = parseFloat(totalDis) + curdis;
            var diffInterval: boolean = true;
            if (i > 0) {

              try{
                 const diff = Math.abs(sortingData[currentKey].gpsts * 1000 - prevKey.gpsts * 1000);
                 const minutes = Math.round(diff / 1000);
              if (minutes >= minInterval) {

                diffInterval = true;
              } else if (minutes < minInterval) {
                diffInterval = false;
              }

              }catch(ex){

              }
             
            }
            if (diffInterval && diffInterval != undefined) {
              if (parseInt(sortingData[currentKey].spd) < 0) sortingData[currentKey].spd = '0';
             // const status = parseInt(sortingData[currentKey].spd) > 5 ? 'Movement' : 'Halt';// by rao

              if(parseInt(sortingData[currentKey].spd) > 5){
                const status='Movement'
                const dateTimeStr = sortingData[currentKey].date || '';
                const parts = dateTimeStr.split(' ');
                const datePart = parts[0] || dateTimeStr;
                const timePart = parts[1] || '';
                const speedFormatted = this.formatSpeed(sortingData[currentKey].spd);
                 const res = {
                sNo: ind,
                DateTime: sortingData[currentKey].date,
                Date: datePart,
                Time: timePart,
                Status: status,
                Location: String(sortingData[currentKey].near).replace('\\r', ''),
                Speed: speedFormatted,
                Distance: this.formatDistance(totalDis)
              };
              const rowVal = {
                value: [datePart, timePart, String(sortingData[currentKey].near).replace('\\r', ''), status, speedFormatted, this.formatDistance(totalDis)]
              };
              this.tableData.push(res);
              tempEx.push(rowVal);
              temp.push(res);
              const tdata = JSON.parse(JSON.stringify(res));
              tdata.ts = sortingData[currentKey].gpsts;
              tdata.gpsts = tdata.ts;
              procesedData.push(tdata);
              ind++;
              }
             
            }
            if ((objKeys.length - 1) == i) {
              // Do not toggle loader visibility here; caller manages loader.
              resolve({ data: procesedData, xldata: tempEx, totalDistance: totalDis });
            }
          }
        } else {
          resolve({ data: [], xldata: [], totalDistance: baseDistance });
        }

      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }
  async downloadAllVehicle() {
    try {
      this.loader.show();
      const chunk: any = await this.comService.chunkObject(this.excelData, 50);

      for (let i = 0; i < chunk.length; i++) {
        await this.excel.generateExcel(
          chunk[i],
          'Movement_Report_' + i + '_ ' + this.comService.timestampToDate(new Date().getTime(), 'DMY') + '.xlsx'
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loader.hide();
    }
  }

  async downloadXL() {
    try {
      this.loader.show();
      await this.excel.generateExcel(
        this.excelData,
        'Movement_Report_' + ' ' + this.comService.timestampToDate(new Date().getTime(), 'DMY') + ' ' + '.xlsx'
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.loader.hide();
    }
  }
}
